import { Link } from 'react-router-dom';

export const CopyWorkflowWebhookToast = ({ copiedWorkflowName, newWorkflowId }) => {
  return (
    <>
      <p>
        A copy of the webhook <b>{copiedWorkflowName}</b> was successfully created
      </p>
      <Link to={`/workflows/webhooks/${newWorkflowId}`}>Go to webhook</Link>
    </>
  );
};
